import {Client} from "@stomp/stompjs";
import React, {useEffect, useRef, useState} from "react";

import {QRCode} from "react-qrcode-logo";
import {connect} from "react-redux";

import nepalPay from "../../../../assets/img/payment/NepalPay.png";
import qrsuccess from "../../../../assets/img/payment/qrsuccess.svg";
import scan from "../../../../assets/img/payment/scan.svg";
import {CheckoutCurrentCart, OtherPayment, UpdatePayment,} from "../../../../redux/actions/Cart.Action";
import ApiConnect from "../../../../Utils/ApiConnect";

const NepalPay = ({
    order_id,
    CurrentCart,
    UpdatePayment,
    CheckoutCurrentCart,
    autoCheckout
}) => {

    const [qrMessage, setQrMessage] = useState("");
    const [qrImage, setQrImage] = useState(scan);
    const [statusMsg, setStatusMsg] = useState("");
    const [socketInfo, setSocketInfo] = useState(null);
    const [showCheckout, setShowCheckout] = useState(false);

    const stompClient = useRef(null);

    useEffect(() => {
        fetchQR(order_id);
        UpdatePayment("NepalPay", CurrentCart.total, "");

        return () => {
            if (stompClient.current) {
                stompClient.current.deactivate();
            }
        };
    }, [order_id]);

    const fetchQR = (orderId) => {
        ApiConnect.get(`POS/Checkout/NepalPayQR?orderid=${orderId}`)
            .then((res) => {
                const data = res.data;
                if (data.http_code === 200) {
                    setQrMessage(data.qrMessage);
                    const parsedSocketInfo = JSON.parse(atob(data.socket));
                    setSocketInfo(parsedSocketInfo);

                    if (data.socket) {
                        initWebsocket(parsedSocketInfo);
                    }
                } else if (data.status === 202) {
                    setQrMessage("");
                    setQrImage(qrsuccess);
                    setStatusMsg("");
                    setSocketInfo(null);
                }
            })
            .catch((err) => console.error(err));
    };

    const initWebsocket = (info) => {
        const client = new Client({
            brokerURL: `${info.url}/nqrws`,
            reconnectDelay: 4000,
            heartbeatIncoming: 0,
            heartbeatOutgoing: 0,

            onConnect: () => {
                client.subscribe("/user/nqrws/check-txn-status", (msg) => {
                    const data = JSON.parse(msg.body);
                    handleSocketMessage(data);
                });

                client.publish({
                    destination: "/nqrws/check-txn-status",
                    body: JSON.stringify({
                        merchant_id: info.merchant_id,
                        request_id: info.request_id,
                        username: info.username,
                        api_token: info.api_token
                    }),
                });
            },

            onStompError: (frame) => console.error("STOMP Error:", frame),
            onWebSocketError: (err) => console.error("WS Error:", err),
        });

        client.activate();
        stompClient.current = client;
    };

    const handleSocketMessage = (msg) => {
        switch (msg?.status) {
            case "ENTR":
            case "PARSED":
                console.log(msg.status);
                break;

            case "COMPLETED":
                console.log("Transaction Completed");
                setQrImage(qrsuccess);
                setQrMessage("");
                setStatusMsg("Payment Received");
                setShowCheckout(true);
                break;

            case "FAILED":
                console.error("Payment Failed");
                break;

            default:
                console.warn("Unknown message:", msg);
        }
    };


    return (
        <>
            <div className="container text-center">
                <h6>{statusMsg}</h6>

                <figure className="figure img-thumbnail">
                    {qrMessage ? (
                        <QRCode
                            value={qrMessage}
                            size={250}
                            qrStyle="dots"
                            logoHeight={50}
                            eyeRadius={50}
                        />
                    ) : (
                        <img src={qrImage} width="250" alt="qr-code" />
                    )}

                    <figcaption className="figure-caption text-center">
                        <img src={nepalPay} width="60" alt="NepalPay" />
                    </figcaption>
                </figure>

                <button
                    className="btn btn-primary w-100"
                    onClick={() => console.log(socketInfo)}
                >
                    Check Status
                </button>
            </div>

            {autoCheckout && showCheckout && (
                <button
                    className="btn btn-primary w-100 mt-2"
                    onClick={() => CheckoutCurrentCart("", "")}
                >
                    Checkout
                </button>
            )}
        </>
    );
};

export default connect(
    (state) => ({ CurrentCart: state.Cart.CurrentCart }),
    { UpdatePayment, OtherPayment, CheckoutCurrentCart }
)(NepalPay);
